import produce from 'immer';

import {
  ROLE_CREATE_FAILURE,
  ROLE_FETCH_FAILURE,
  ROLE_FETCH_SUCCESS,
  ROLE_UPDATE_FAILURE,
  ROLES_FETCH_SUCCESS,
} from '@actions/role';

const initialState: IRoleStore = {
  currentRole: null,
  roles: null,
  error: null,
};

export default (state: IRoleStore = initialState, action: any) =>
  produce(state, (draftState: IRoleStore) => {
    switch (action.type) {
      case ROLE_FETCH_SUCCESS:
        draftState.currentRole = action.response;
        draftState.error = null;

        return;

      case ROLE_CREATE_FAILURE:
      case ROLE_UPDATE_FAILURE:
      case ROLE_FETCH_FAILURE:
        draftState.error = action.error;

        return;
      case ROLES_FETCH_SUCCESS:
        draftState.roles = action.response;
        draftState.error = null;

        return;
    }
  });
